import { render, staticRenderFns } from "./PackageList.vue?vue&type=template&id=f08186c4&scoped=true"
import script from "./PackageList.vue?vue&type=script&lang=js"
export * from "./PackageList.vue?vue&type=script&lang=js"
import style0 from "./PackageList.vue?vue&type=style&index=0&id=f08186c4&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f08186c4",
  null
  
)

export default component.exports